import React from 'react';
import NavigationHelper from "./NavigationHelper";
import Icon from 'react-icons-kit';
import {link} from 'react-icons-kit/entypo/link';
import PropTypes from "prop-types";

function HistoryLink({ state, url, style, tooltip, className, onClick, children, navigateIcon = <Icon icon={link}/> }) {
    
    return <a href="#" style={style} title={tooltip} className={className} onClick={(evt) => {

        evt.preventDefault();

        NavigationHelper.navigate(url,state);

        if(onClick) {
            onClick();
        }

    }}>{navigateIcon}{children}</a>
    
}

HistoryLink.proptTypes = {
    state: PropTypes.object,
    url: PropTypes.string,
    style: PropTypes.object,
    tooltip: PropTypes.any,
    className: PropTypes.string,
    onClick: PropTypes.func,
    navigateIcon: PropTypes.any
};

export default HistoryLink;


// WEBPACK FOOTER //
// ./src/common/HistoryLink.js